import { apiClient } from './axios';

import type {
  CreateScraperDto,
  Scraper,
  ScraperImportDto,
  ScraperQuery,
  ScraperRunResult,
  TestScraperDto,
  UpdateScraperDto,
} from '@repo/shared-types';

export const scrapersApi = {
  getAll: async (query?: ScraperQuery) => {
    const res = await apiClient.get<Scraper[]>('/scrapers', { params: query });
    return res.data;
  },
  getOne: async (id: string) => {
    const res = await apiClient.get<Scraper>(`/scrapers/${id}`);
    return res.data;
  },
  create: async (data: CreateScraperDto) => {
    const res = await apiClient.post<Scraper>('/scrapers', data);
    return res.data;
  },
  update: async (id: string, data: UpdateScraperDto) => {
    const res = await apiClient.patch<Scraper>(`/scrapers/${id}`, data);
    return res.data;
  },
  remove: async (id: string) => {
    await apiClient.delete(`/scrapers/${id}`);
  },
  /** Run an unsaved config with sample args (test before saving). */
  test: async (data: TestScraperDto) => {
    const res = await apiClient.post<ScraperRunResult>('/scrapers/test', data);
    return res.data;
  },
  /** Run a saved scraper by id with sample args. */
  run: async (id: string, args: Record<string, unknown> = {}) => {
    const res = await apiClient.post<ScraperRunResult>(`/scrapers/${id}/run`, { args });
    return res.data;
  },
  export: async (ids?: string[]) => {
    const res = await apiClient.get<{ scrapers: Record<string, unknown>[] }>('/scrapers/export', {
      params: ids?.length ? { ids: ids.join(',') } : undefined,
    });
    return res.data;
  },
  import: async (data: ScraperImportDto) => {
    const res = await apiClient.post<{ created: number; updated: number }>(
      '/scrapers/import',
      data,
    );
    return res.data;
  },
};
